import {
  PromoBannerRequestParams,
  PromoForPromoBanner,
} from '../../../../../common/types/Promociones'
import * as fetchPromoNeumatico from '../../../../../common/api/neumaticos'
import * as fetchPromoBaterias from '../../../../../coche/baterias/api/fetchInfoPromocion'
import * as fetchPromoAceites from '../../../../../coche/aceites/catalogo/api/fetchInfoPromocion'

export type FetchPromoFunction = (
  params: PromoBannerRequestParams
) => Promise<PromoForPromoBanner>

export const getFetchFunction = (tipoProducto: string): FetchPromoFunction => {
  switch (tipoProducto) {
    case 'neumatico':
      return fetchPromoNeumatico.fetchInfoPromocion
    case 'bateria':
      return fetchPromoBaterias.fetchInfoPromocion
    case 'aceite':
      return fetchPromoAceites.fetchInfoPromocion
    default:
      return null
  }
}
